import { DateTimeDisplay } from "@/components/pieces/DateTimeDisplay";

interface AnnouncementUpcomingInfoProps {
  targetStartDate?: string | null;
  participantPrelaunchVisibility?: boolean | null;
  requiredSendLaunchEmail?: boolean | null;
  isAdmin?: boolean;
}

export function AnnouncementUpcomingInfo({
  targetStartDate,
  participantPrelaunchVisibility,
  requiredSendLaunchEmail,
  isAdmin = false,
}: AnnouncementUpcomingInfoProps) {
  if (!targetStartDate) return null;

  if (!isAdmin) {
    return (
      <>
        💡 You will see this announcement on{" "}
        <DateTimeDisplay time={targetStartDate} formatString="MMM do yyyy" />
      </>
    );
  }

  const viewUser = "Participants";

  if (participantPrelaunchVisibility && requiredSendLaunchEmail) {
    return (
      <>
        💡 {viewUser} will see this announcement and receive a notification on{" "}
        <DateTimeDisplay time={targetStartDate} formatString="MMM do yyyy" />
      </>
    );
  } else if (participantPrelaunchVisibility && !requiredSendLaunchEmail) {
    return (
      <>
        💡 {viewUser} will see this announcement on{" "}
        <DateTimeDisplay time={targetStartDate} formatString="MMM do yyyy" />
      </>
    );
  } else if (!participantPrelaunchVisibility && requiredSendLaunchEmail) {
    return (
      <>
        💡 {viewUser} will receive a notification with this information on{" "}
        <DateTimeDisplay time={targetStartDate} formatString="MMM do yyyy" />
      </>
    );
  } else {
    return (
      <>
        💡 This announcement will surface to participants on{" "}
        <DateTimeDisplay time={targetStartDate} formatString="MMM do yyyy" />
      </>
    );
  }
}
